module Sxc.Site {
    export class RoomGallery {
        private roomlist;

        constructor(roomlist) {
            this.roomlist = roomlist;
        }


        /*Média galéria ill. profil oldal kezelése*/
        private pagingProcess : boolean = true;
        private profileMedia : any = null;
        private profileMediaFanClub : any = null;
        private profileMediaVideos : any = null;
        private profileMediaMaxPage : number = null;
        private profileMediaFanClubMaxPage : number = null;
        private profileMediaMaxPageVideos : number = null;
        private perPage : number = 20;
        private perPageFanClub : number = 9999;
        private profilePage : number = 0;
        private profilePageVideos : number = 0;
        private profileLastId : string = '';
        private fanClubBannerRendered: boolean = false;
        private lovenseWebTurnedOn: boolean = true;

        private useMixedView = true;
        private useMixedViewWithBigVertical = true; // Not implemented
        private useMixedViewFanclub = true;
        private useMixedViewFanPacks = true;
        public grid = null;
        public gridVideos = null;
        public gridFanclub = null;
        public gridFanPacks = null;

        scrollToMenu(){
            $('html, body').animate({scrollTop: $(".perfnav").offset().top}, 300), function() {};
            setTimeout(function (){
                $('html, body').animate({scrollTop: $(".perfnav").offset().top}, 300), function() {
                };
            },300)
            $('.sxc-chat, .frame-content').animate({scrollTop: ($(".sxcc-wrapper").hasClass("hiddenchat")?0:$(".sxcc-wrapper").height()+25)}, 300, function(){});
            setTimeout(function (){
                $('.sxc-chat, .frame-content').animate({scrollTop: ($(".sxcc-wrapper").hasClass("hiddenchat")?0:$(".sxcc-wrapper").height()+25)}, 300, function(){
                });
            },300);


        }

        addedLastRoomsIfRequiredInterval=false;
        addLastRoomsIfRequiredInterval(scroller){
            /*if(this.addedLastRoomsIfRequiredInterval){return;}
            this.addedLastRoomsIfRequiredInterval=true;
            setInterval(() => {
                this.roomlist.addBigroomsAndLAstroomsInPopup('.performercontent',this.profilePage,Math.ceil(this.profileMedia.media.length / this.perPage),);
            },1000);*/
        }

        addUserDataFrame(roomId : string) {
            let _this = this;

            if(_this.useMixedView){
                try{_this.grid.packery('destroy');}catch ( e ){}
                _this.grid = null;
                try{_this.gridVideos.packery('destroy');}catch ( e ){}
                _this.gridVideos = null;
            }
            if(_this.useMixedViewFanclub){
                try{_this.gridFanclub.packery('destroy');}catch ( e ){}
                _this.gridFanclub = null;
            }
            if(_this.useMixedViewFanPacks){
                try{_this.gridFanPacks.packery('destroy');}catch ( e ){}
                _this.gridFanPacks = null;
            }
            let roomData = window["chatClient"].app.chatServer.roomList.getByID(roomId);
            /*if(typeof roomData.publicData !=="undefined" && typeof roomData.publicData.toys !=="undefined"){
                let hasToys = roomData.publicData.toys && !!roomData.publicData.toys.default;
            }else{ let hasToys =false;  }*/

            this.profileLastId = roomId;
            this.profilePage   = 0;
            this.profilePageVideos   = 0;
            this.profileMedia  = null;
            this.profileMediaVideos  = null;

            $('.sxcc-user-data').css("visibility","hidden");

            let streamBottom     = Math.round($('.sxcc-stream').outerHeight(true)) + Math.round($('.sxccb-actions').outerHeight(true)) + 8 + 157;

            let mainElement      = $('<div>').addClass('sxcc-user-data').data('perfid', roomId).css({top: streamBottom+'px'});
            let contentElement   = $('<div>').addClass('performercontent');
            let descElement      = $('<div>').addClass('performerdesc');
            let perfnavElement   = $('<div>').addClass('perfnav');
            let mediaElement     = $('<ul>').addClass('mediagallery');
            let videosElement    = $('<div>').addClass('videogallery').append('<ul id="videogalleryul" class="mediagallery"></ul>');
            let giftsElement     = $('<div>').addClass('gifts');
            let fanclubElement   = $('<ul>').addClass('mediagallery').addClass('fanclub')
            let giftpricesElement   = $('<div>').addClass('giftprices');
            let fanPacksElement      = $('<ul>').addClass('mediagallery').addClass('fanpacks')

            if(this.useMixedView){
                mediaElement.addClass('mixedview');
                if(this.useMixedViewWithBigVertical){
                    mediaElement.addClass('mixedviewbigvertical');
                }
                videosElement.find("#videogalleryul").addClass('mixedview');
            }
            if(this.useMixedViewFanclub){
                fanclubElement.addClass('mixedview');
                if(this.useMixedViewWithBigVertical){
                    fanclubElement.addClass('mixedviewbigvertical');
                }
            }
            if(this.useMixedViewFanPacks){
                fanPacksElement.addClass('mixedview');
                if(this.useMixedViewWithBigVertical){
                    fanPacksElement.addClass('mixedviewbigvertical');
                }
            }

            $('.sxcc-user-data').html("").css("min-width","100%").css("max-width","100%");

            let closeElement= $('<div class="close mypageclose"><a onclick="$(\'body\').trigger($.Event(\'keydown\', { keyCode: 27 }));" href="#"><i></i></a></div>');
            let videoPlayerTeaserElement= $('<div id="video-player-teaser-cont"></div>');

            perfnavElement.append(closeElement);

            mainElement.append(videoPlayerTeaserElement);
            mainElement.append(perfnavElement).append(descElement.hide()).append(videosElement.hide()).append(giftsElement.hide()).append(fanclubElement.hide()).append(giftpricesElement.hide()).append(fanPacksElement.hide());
            mainElement.append(contentElement.append(mediaElement));

            let videoElement   = $('<video>').attr('id', 'video-player').attr('width', '100%').attr('controls', 'true').attr("controlsList","nodownload").attr("oncontextmenu","return false;").css("max-height","100vh;");
            let pictureElement = $('<img>').attr('id', 'video-poster').attr('src', '').attr('width', '100%').css("max-height","calc(100vh - 50px)").css("width","auto");
            let messageElement = $('<div>').attr('id', 'video-message').hide();
            let videoContainerElement = $('<div>').attr('id', 'videoModal').attr('style', 'display: none; max-width: 1180px; max-height: 100%; padding: 0px;').append(pictureElement).append(videoElement).append(messageElement).append('<span class="loading-animation-1"></span>');

            let popupHTML = '<section class="popup" id="porfilepopup" style="display: none;"> <div class="window small"> <div class="close" onclick="$(\'#porfilepopup\').hide()"></div> <div class="header"></div> <div class="poparea maxheight"> <div class="popcontent"> <div class="scroll-wrapper inner scroll"></div> </div> </div>  </div> </section>';

            mainElement.append(videoContainerElement).append('<div class="chat_loding_cont"><span class="loading-animation-1"></span></div>').append(popupHTML);

            $('.sxcc-user-data').remove();
            $('.sxcc-wrapper').append(mainElement);

            let scrollTimer, lastScrollFireTime = 0;
            $('.sxc-chat, .frame-content').scroll(scroller);
            $(window).scroll(scroller);
            this.addLastRoomsIfRequiredInterval(scroller);

            //Get Profile data
            $.ajax({
                url: '/page/profile?perfID='+roomId+'&tokenID='+window["chatClient"].app.options.auth.tokenID+"&dtype=babes",
                dataType: 'json'
            }).done((dataJson) => {
                _this.profileMedia = dataJson;
                _this.profileMediaVideos = JSON.parse(JSON.stringify(dataJson));//kell hogy ne referencia legtyen
                _this.profileMediaMaxPage = Math.ceil(_this.profileMedia.media.length / _this.perPage);

                mediaRenderer(_this.profileMedia,".performercontent",_this.profilePage);
                let sordb=_this.roomlist._getColcountPerRow('.performercontent .mediagallery .mg-item');
                if(!_this.useMixedView){
                    if(_this.profileMedia.media.length > 4 && _this.profileMedia.media.length>(sordb*(_this.roomlist.bigroomrowsize+_this.roomlist.bigroomstartrow-1)-(_this.roomlist.bigroomrowsize*_this.roomlist.bigroomcolsize))){
                        _this.roomlist.addBigroomsAndLAstroomsInPopup('.performercontent',_this.profilePage,_this.profileMediaMaxPage);
                    }
                }

                //Videók fül megjelenítése
                this.roomlist.helpers.log("Check videos tab: _this.profileMedia.media.length:"+_this.profileMedia.media.length);
                let videoslength=0;let data1JsonArr=[];
                $.each(dataJson.media,function (itemKey, itemValue) {  if(itemValue.ext == 'video'){videoslength++;data1JsonArr.push(dataJson.media[itemKey])}  });
                _this.profileMediaVideos.media=data1JsonArr;
                _this.profileMediaMaxPageVideos = Math.ceil(this.profileMediaVideos.media.length / _this.perPage);
                _this.roomlist.helpers.log("Check videos tab: _this.profileMediaVideos.media.length:"+_this.profileMediaVideos.media.length+" videoslength:"+videoslength);
                if(_this.profileMedia.media.length>=40 && videoslength>=8) {
                    mediaRenderer(this.profileMediaVideos, ".videogallery", _this.profilePageVideos, true);
                    if(!_this.useMixedView){
                        if (this.profileMediaVideos.media.length > 4 && _this.profileMediaVideos.media.length > (sordb * (_this.roomlist.bigroomrowsize + _this.roomlist.bigroomstartrow - 1) - (_this.roomlist.bigroomrowsize * _this.roomlist.bigroomcolsize))) {
                            _this.roomlist.addBigroomsAndLAstroomsInPopup('.videogallery', _this.profilePageVideos, _this.profileMediaMaxPageVideos, ".performercontent");
                        }
                    }
                }else{ $("#profile_videos_li").hide(); }

                //gifts tab legyen aktív, ha szükséges
                if(_this.roomlist.default_giftpage_show){
                    _this.roomlist.default_giftpage_show=false;
                    $("#profile_gifts").click();
                }

                this.initLovense(roomId);
            });

            $(document).on('afterShow.fb', (e, instance, slide) => {
                window["chatClient"].app.view.ignoreEsc(true);
            });
            $(document).on('beforeClose.fb', (e, instance, slide) => {
                setTimeout(() => {
                    window["chatClient"].app.view.ignoreEsc(false);
                    $(".fancybox-container").remove();//fancy box bug miatt, mert néha nem zárta be
                }, 500);
            });

            //Függvények

            function mediaRenderer(dataJson, parentElement,profilePage,onlyGallery = false){
                _this.pagingProcess = true; let mediaElement = $(parentElement+' .mediagallery');

                //teaser video
                if(typeof dataJson.teaserVideo !== 'undefined' && dataJson.teaserVideo != null && typeof dataJson.teaserVideo.streamUrl !== 'undefined' && dataJson.teaserVideo.streamUrl != null) {
                    mediaElement.attr("data-teaser",dataJson.teaserVideo.id);
                    _this.roomlist.roomView.showTeaser();
                }

                $('.sxcc-user-data .loading-animation-1').hide();

                /*if(this.profilePage == 0) {
                    let clearElement    = $('<div>').addClass('clear');
                    let ratingElement   = $('<div>').addClass('rating');
                    for(var i = 1; i <= dataJson.rating; i++) { let starOnElement   = $('<div>').addClass('star_on');  ratingElement.append(starOnElement); }
                    for(var j = dataJson.rating + 1; j <= 5; j++) { let starOffElement  = $('<div>').addClass('star_off'); ratingElement.append(starOffElement); }
                    ratingElement.append(clearElement);

                    let descriptionElement = $('<button>').html('leírás');
                    let divTagsElement  = $('<div>').addClass('tags').html(dataJson.tags);
                    let h1NameElement   = $('<h1>').html(dataJson.name);
                    let divEmptyElement = $('<div>').append(h1NameElement).append(ratingElement).append(divTagsElement).append(descriptionElement);
                    let centerElement   = $('<div>').addClass('abscenter').append(divEmptyElement);
                    let innerElement    = $('<div>').addClass('box-inner').addClass('profile').append(centerElement);
                    let boxElement      = $('<div>').addClass('box').append(innerElement);
                    let liElement       = $('<li>').append(boxElement);

                    descriptionElement.on('click', () => {
                        $("#porfilepopup").find('.header').html(dataJson.name);
                        $("#porfilepopup").find('.popcontent').find('.inner').html(dataJson.desc);

                        $("#porfilepopup").show();
                    });

                    mediaElement.append(liElement);
                }*/

                addImagesVideosTabs(parentElement);
                if(typeof dataJson.fanpacks != 'undefined' && dataJson.fanpacks.length > 0){
                    if(_this.useMixedViewFanPacks){
                        if(_this.gridFanPacks == null){
                            _this.gridFanPacks = $('.fanpacks.mixedview').packery({
                                itemSelector: '.mg-item',
                                gutter: 0,percentPosition: true
                            });
                        }
                    }
                }
                if (typeof dataJson.fanclub !== 'undefined' && typeof dataJson.fanclub.mediaList !== 'undefined' && !onlyGallery) {
                    if(_this.useMixedViewFanclub){
                        if(_this.gridFanclub == null){
                            _this.gridFanclub = $('.fanclub.mixedview').packery({
                                itemSelector: '.mg-item',
                                gutter: 0,percentPosition: true
                            });
                        }
                    }
                    renderFanClubMediaItems(dataJson.fanclub, _this.profileLastId);
                    _this.profileMediaFanClub = dataJson.fanclub;
                    _this.profileMediaFanClubMaxPage= Math.ceil(_this.profileMedia.fanclub.mediaList.length / _this.perPageFanClub);
                }
                //addgiftsTab(_this.profileLastId);  Old design

                // Add Fanpack content
                let horzontalCounterFp=1;
                if(typeof dataJson.fanpacks != 'undefined' && dataJson.fanpacks.length > 0 && $(".fanpacks li").length==0){
                    dataJson.fanpacks.map((item, index) => {
                        const img = $('<img>')
                            .addClass('')
                            .attr('src', item.thumbnail);

                        const thumbnail = $('<div>').addClass('thumbnail');
                        thumbnail.append(img);

                        const badge = $('<span>')
                            .addClass('badge-link')
                            // @ts-ignore
                            .html('<div style="background-color: transparent">'+(__currLang=='en'?item.title_en:item.title)+' 🔗<!--<img style="width: 12px;height: 12px;display: inline;background-color: transparent" src="/design/default/babes/images/siteout.svg" /></div>-->');



                        const boxInner = $('<div>').addClass('box-inner profile').append(thumbnail);


                        const link = $('<a>').attr('href','#').addClass('link');
                        link.attr('href', item.packageUrl)
                            .attr('data-thumb', item.thumbnail)
                            .attr('target', "_blank")
                            .addClass('');

                        const box = $('<div>').addClass('box').append(boxInner).append(link);

                        badge.mousedown(() => {
                            window.open(item.packageUrl,"_blank");
                        });
                        box.append(badge);

                        const ms = new Date().getTime();
                        const listItem = $('<li>')
                            .attr('data-id', 'mg-item-' + ms + (index + 1))
                            .addClass('mg-item')
                            .addClass('mg-item-'+ ms + (index + 1))
                            .append(box);


                        console.log("fanpack", listItem);

                        if(_this.useMixedViewFanPacks){
                            if(item.is_vertical){
                                $(listItem).attr('data-vertical',"true");
                                $(listItem).addClass('mg-i-vertical');
                                if(_this.useMixedViewWithBigVertical){
                                    $(listItem).find("img:first").attr("src",$(listItem).find("img:first").attr("data-big-img"));
                                }
                            }else{
                                horzontalCounterFp++;
                                if(horzontalCounterFp%12==0){
                                    $(listItem).addClass(_this.useMixedViewWithBigVertical?'mg-i-horizontal-x2':'mg-i-horizontal');
                                    if(_this.useMixedViewWithBigVertical){
                                        $(listItem).find("img:first").attr("src",$(listItem).find("img:first").attr("data-big-img"));
                                    }
                                    horzontalCounterFp=1;
                                }else{
                                    $(listItem).addClass('mg-i-horizontal');
                                }
                                //$(listItem).addClass('mg-i-horizontal');
                            }

                            try{_this.gridFanPacks.append(listItem).packery( 'appended',listItem );}catch (err){console.error(err);}
                        }else{
                            fanPacksElement.append(listItem);
                        }
                    });
                }

                if(parentElement==".performercontent"){_this.profilePage=profilePage+1;}
                else{_this.profilePageVideos=profilePage+1;}
                _this.roomlist.helpers.log("before profilePage++ "+profilePage);

                _this.pagingProcess = false;

                addTabsBar(_this.profileLastId);
                _this.facybox_settings();

                if(_this.roomlist.click_fanclub){
                    setTimeout(function () {
                        $("#profile_fanclub").click();
                        _this.roomlist.click_fanclub = false;
                    },500);
                }else if(_this.roomlist.click_fanclub_chat){
                    $("#profile_fanclub_message").click();
                    _this.roomlist.click_fanclub_chat = false;
                }else if(_this.roomlist.click_fanclub_join){
                    $("#profile_fanclub_start").click();
                    _this.roomlist.click_fanclub_join = false;
                }else if(_this.roomlist.click_fanpacks){
                    $("#profile_fanpacks").click();
                    _this.roomlist.click_fanpacks = false;
                }

                //függvények
                function getFavHeart(roomId, forced = false, isFav=false){
                    // @ts-ignore
                    if(!__isLoggedMember){
                        return "";
                    }
                    let is_fav = false;
                    try{ is_fav = _this.roomlist.last_favourites.indexOf("mypage/"+roomId+"/") !==-1;}
                    catch (e) { is_fav = false; }
                    if(forced){ is_fav=isFav;}
                    let elementHeart = '<img class="tw-w-[21px] tw-h-[17px]" src="/design/default/babes/images/heart_'+(is_fav?"on.svg":"gray.svg")+'" title="'+_this.roomlist.helpers.getTranslate((is_fav?"mypagedisplay_delfavorite":'mypagedisplay_addfavorite'))+'">';
                    if(forced){   return elementHeart; }
                    let element = '<a class="tw-min-h-[45px] tw-ml-3.5 md:tw-ml-2 md:tw-mr-7 !tw-flex md:!tw-inline-block tw-flex-col tw-justify-center md:tw-mt-0 room-fav room-fav-'+roomId+' '+(is_fav?"on":"")+'" href="javascript:void(0)">'+elementHeart+'</a>';
                    return element;
                }

                function addTabsBar(roomId){
                    console.log("AddTabsBar");
                    if(perfnavElement.find("h1").length==0){
                        let ulTagsElement  = $('<ul>').addClass('perftags');
                        for(let tag in dataJson.tags){  ulTagsElement.append('<li>'+dataJson.tags[tag]+'</li>'); }
                        descElement.append(ulTagsElement);
                        descElement.append(''+dataJson.desc+"<br><br>");

                        // @ts-ignore
                        perfnavElement.append('<h1 class="'+(!__isLoggedMember?'md:!tw-mr-7':'')+'">'+dataJson.name +  '<span>'+getFavHeart(roomId)+'</span>' + '</h1> ' +
                            '<ul id="perfnavul" class="tw-flex tw-flex-row tw-flex-wrap">' +
                            '<li class="md:!tw-hidden">' + getFavHeart(roomId) + "</li> " +
                            '<li class="selected" id="profile_gallery_li"><a id="profile_gallery" href="javascript:void(0)">'+_this.roomlist.helpers.getTranslate('profile_gallery')+'</a></li>' +
                            '<li id="profile_desc_li"><a id="profile_desc" href="javascript:void(0)">'+_this.roomlist.helpers.getTranslate('profile_about')+'</a></li>' +
                            '<li id="profile_videos_li"><a id="profile_videos" href="javascript:void(0)">'+_this.roomlist.helpers.getTranslate('header_menu_videos')+'</a></li>' +
                            '<li id="profile_gifts_li"><a id="profile_gifts" href="javascript:void(0)"><span id="mypagedisplay_send_gift_full">'+_this.roomlist.helpers.getTranslate('mypagedisplay_send_gift')+'</span><span id="mypagedisplay_send_gift_short">'+_this.roomlist.helpers.getTranslate('mypage_gift_tab_text')+'</span></a></li>' +
                            '<li id="profile_giftprices_li" class="hidden"><a id="profile_giftprices" href="javascript:void(0)">'+_this.roomlist.helpers.getTranslate('profile_giftprices')+'</a></li>' +
                            '</ul>');
                        perfnavElement.find(".room-fav").on("click",function (){
                            _this.roomlist.babesHandler.favoriteHandler(roomId, ".room-fav-",true,$(".room-fav").hasClass("on"));
                            if($(".room-fav").hasClass("on")){$(".room-fav").removeClass("on")}
                            else{$(".room-fav").addClass("on")}
                            $(".room-fav").html(getFavHeart(roomId,true,$(".room-fav").hasClass("on")));
                        })

                        const fanclub = dataJson.fanclub;
                        const navigation = $('#perfnavul');

                        if (typeof fanclub !=="undefined" && fanclub) {
                            navigation.append('\
                                <li id="profile_fanclub_li">\
                                    <a id="profile_fanclub" href="javascript:void(0)">\
                                        ' + _this.roomlist.helpers.getTranslate('mypagedisplay_menu_fanclub') + '\
                                    </a>\
                                </li>\
                            ');

                            if (fanclub.hasActiveSubscription) {
                                // `Send message` button
                                navigation.append('\
                                    <li id="profile_fanclub_message_li" class="btn-action">\
                                        <a id="profile_fanclub_message" href="javascript:void(0)" class="btn">\
                                            ' + _this.roomlist.helpers.getTranslate('mypagedisplay_menu_fanclub_message') + '\
                                        </a>\
                                    </li>\
                                ');

                                $('body').on('click', '#profile_fanclub_message', () => {
                                    window.sxc.fanclub.panel.showConversation(_this.roomlist.roomView.last_opened_room);
                                });
                            } else {
                                // `Be my fan` button
                                navigation.append('\
                                    <li id="profile_fanclub_start_li" class="btn-action">\
                                        <a id="profile_fanclub_start" href="javascript:void(0)" class="btn">\
                                            ' + _this.roomlist.helpers.getTranslate('mypagedisplay_menu_fanclub_start') + '\
                                        </a>\
                                    </li>\
                                ');

                                $('body').on('click', '#profile_fanclub_start', () => {
                                    // @ts-ignore
                                    if (window.chatClient.app.options.auth.tokenID === 'guest') {
                                        // @ts-ignore
                                        window.chatClient.app.showRegisterNeeded('free');
                                    } else {
                                        // @ts-ignore
                                        window.sxc.fanclub.panel.showSubscribe(_this.roomlist.roomView.last_opened_room, __fanclubCurrency);
                                    }
                                });
                            }
                        }

                        // add navigation link to Fan Packs
                        if(typeof dataJson.fanpacks != 'undefined' && dataJson.fanpacks.length > 0){
                            navigation.append('\
                                <li id="profile_fanpacks_li">\
                                    <a id="profile_fanpacks" href="javascript:void(0)">\
                                        ' + _this.roomlist.helpers.getTranslate('mypagedisplay_menu_fanpack') + '\
                                    </a>\
                                </li>\
                            ');
                        }

                        //meta adat módosítás
                        $("#meta_title").attr("content-old",  $("#meta_title").attr("content"));
                        $("#meta_og_description").attr("content-old",  $("#meta_og_description").attr("content"));
                        $("#meta_description").attr("content-old",  $("#meta_description").attr("content"));
                        $("#meta_image").attr("content-old",  $("#meta_image").attr("content"));
                        $("#meta_title").attr("content", _this.roomlist.helpers.escapeHtml($("title").text()));
                        var desc = dataJson.desc.replace(/(<([^>]+)>)/ig, ' ');
                        desc = _this.roomlist.helpers.escapeHtml(desc);
                        desc = desc.length > 80 ? desc.slice(0, 80 - 1) + "…" : desc;
                        $("#meta_og_description").attr("content", desc);
                        $("#meta_description").attr("content", desc);
                        $("#meta_image").attr("content", "https:"+dataJson.profilepic);

                        // Tab klikkelések lekezelése
                        $("#profile_gallery").click(function () {
                            descElement.hide(); fanPacksElement.hide(); videosElement.hide();giftsElement.hide();fanclubElement.hide();giftpricesElement.hide();contentElement.show();

                            $("#perfnavul > li").removeClass("selected");
                            $("#profile_gallery_li").addClass("selected");
                            handleFanClubButtonVisibility(fanclub);
                            _this.scrollToMenu();
                            if(_this.useMixedView  && _this.grid !== null){
                                _this.grid.packery()
                            }
                        });
                        $("#profile_desc").click(() => desclick(fanclub));
                        $("#profile_videos").click(function () {
                            descElement.hide(); fanPacksElement.hide();contentElement.hide();giftsElement.hide();fanclubElement.hide();giftpricesElement.hide();videosElement.show();

                            $("#perfnavul > li").removeClass("selected");
                            $("#profile_videos_li").addClass("selected");
                            handleFanClubButtonVisibility(fanclub);
                            _this.scrollToMenu();
                            if(_this.useMixedView && _this.gridVideos !== null){
                                _this.gridVideos.packery()
                            }
                        });
                        $("#profile_gifts").click(function () {
                            // @ts-ignore
                            if(__isLoggedMember === true) {
                                // @ts-ignore
                                openBabesGiftsPopup(dataJson.gifts.full,dataJson.name,dataJson.gifts.imageServerAssetURL,_this.profileLastId,_this.roomlist.helpers.getTranslate('mypage_gift_suprise').replace("{{name}}",dataJson.name),dataJson.gifts.smartToys_available,dataJson.profilepic);
                            }
                            else{ _this.roomlist.babesHandler.showPopup('loginpop'); }

                            //old design
                            //descElement.hide(); fanPacksElement.hide(); contentElement.hide();videosElement.hide();fanclubElement.hide();giftsElement.show();

                            //old design
                            /*descElement.hide();contentElement.hide();videosElement.hide();giftsElement.show();
                            $("#perfnavul > li").removeClass("selected");
                            $("#profile_gifts_li").addClass("selected");
                            handleFanClubButtonVisibility(fanclub);
                            scrollToMenu();
                            */
                        });
                        $("#profile_fanclub").click(function () {
                            descElement.hide(); fanPacksElement.hide();contentElement.hide();videosElement.hide();giftsElement.hide();giftpricesElement.hide();fanclubElement.show();

                            $("#perfnavul > li").removeClass("selected");
                            $("#profile_fanclub_li").addClass("selected");
                            handleFanClubButtonVisibility(fanclub);
                            _this.scrollToMenu();

                            if(window.location.href.indexOf("#fanclub")===-1){
                                window.history.pushState({},"", window.location.href.replace("#fanpacks","")+"#fanclub");
                            }

                            if(_this.useMixedViewFanclub && _this.gridFanclub !== null){
                                _this.gridFanclub.packery()
                            }
                        });
                        $("#profile_giftprices").click(function () {
                            descElement.hide(); fanPacksElement.hide();contentElement.hide();videosElement.hide();giftsElement.hide();fanclubElement.hide();giftpricesElement.show();

                            $("#perfnavul > li").removeClass("selected");
                            $("#profile_giftprices_li").addClass("selected");
                            handleFanClubButtonVisibility(fanclub);

                            _this.scrollToMenu();
                        });
                        $("#profile_fanpacks").click(function () {
                            descElement.hide(); contentElement.hide();videosElement.hide();giftsElement.hide();giftpricesElement.hide();fanclubElement.hide(); fanPacksElement.show();

                            $("#perfnavul > li").removeClass("selected");
                            $("#profile_fanpacks_li").addClass("selected");

                            _this.scrollToMenu();

                            if(window.location.href.indexOf("#fanpacks")===-1){
                                window.history.pushState({},"", window.location.href.replace("#fanclub","")+"#fanpacks");
                            }

                            if(_this.useMixedViewFanPacks && _this.gridFanPacks !== null){
                                _this.gridFanPacks.packery()
                            }

                            if(_this.useMixedViewFanPacks){
                                for (var i = 0; i < 10; i++) {
                                    if(!$("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                                        break;
                                    }
                                    setTimeout(function () {
                                        if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                                            _this.gridFanPacks.packery();
                                        }
                                    },500*i*(i/2) );
                                }
                            }
                        });

                        //ha guest
                        if (window["chatClient"].app.options.auth.tokenID === "guest") {
                            $(".mediagallery").addClass("blockedcontent");
                            $(".blockedcontent").on("click", ".mg-item",function (event) {
                                event.stopPropagation();
                                event.stopImmediatePropagation();
                                //_this.showToast(_this.roomlist.helpers.getTranslate('guest_gallyery_notif'),true);
                                window['chatClient'].app.showRegisterNeeded("free");
                            });
                        }
                        if(dataJson.media.length==0){
                            $("#profile_gallery_li").hide();
                            desclick(fanclub);

                            //ha nincs gift vagy zizgő, a block eltüntetése
                            if($(".sxcc-special-gift-panel").css('visibility')=="hidden"){
                                $(".sxcc-user-data").css("margin-top","-147px").css("display","inline-block");
                            }
                        }
                    }
                }

                function addImagesVideosTabs(parentElement) {
                    //Rendezés időpont szerint csökkenőbe
                    for (var i = 0; i < dataJson.media.length; i++) { dataJson.media[i].created=new Date(dataJson.media[i].created);}

                    dataJson.media=dataJson.media.sort((a, b) => b.created - a.created);

                    if(_this.useMixedView){
                        if(parentElement==".performercontent"){
                            if(_this.grid == null){
                                _this.grid = $(parentElement+' .mixedview').packery({
                                    itemSelector: '.mg-item',
                                    gutter: 0,percentPosition: true
                                });
                            }
                        }
                        else{
                            if(_this.gridVideos == null) {
                                _this.gridVideos = $(parentElement + ' .mixedview').packery({
                                    itemSelector: '.mg-item',
                                    gutter: 0, percentPosition: true
                                });
                            }
                        }
                    }

                    let counter=0;let horzontalCounter=1;
                    _this.roomlist.helpers.log("medirender ("+parentElement+") data: "+dataJson.media.length+" "+profilePage+"/");
                    $.each(dataJson.media.slice((profilePage) * (_this.perPage  ), ((profilePage+1) * _this.perPage) ), function(itemKey, itemValue) {
                        counter++;
                        let itmeId=(new Date().getTime())+counter;
                        if(itemValue.ext == 'image') {
                            let picElement   = $('<img>').attr('src', !_this.useMixedView ?itemValue.url_thumb:(itemValue.is_vertical?itemValue.url_bigbox:itemValue.url_thumb)).attr('data-big-img', itemValue.url_bigbox);
                            if(_this.useMixedView){
                                /*if(itemValue.is_vertical){
                                    picElement.css("height",itemValue.ybig).css("width",itemValue.xbig);
                                }else{
                                    picElement.css("height",itemValue.y).css("width",itemValue.x);
                                }*/
                            }
                            let linkElement  = $('<a>').append(picElement).attr('href',"#");
                            if (window["chatClient"].app.options.auth.tokenID !== "guest") {
                                linkElement.attr('href', itemValue.url).addClass('fancybox').attr('data-fancybox', 'gallery').attr("data-protect","true");
                            }
                            linkElement.mousedown(function () {
                                _this.roomlist.babesHandler.activitycheckeradd();
                            });
                            let innerElement = $('<div>').addClass('box-inner').addClass('profile').append(linkElement);
                            let boxElement   = $('<div>').addClass(_this.useMixedView?'box-mixed':'box').append(innerElement);
                            let liElement    = $('<li data-id="'+'mg-item-'+itmeId+'">').addClass("mg-item").addClass('mg-item-'+itmeId).append(boxElement);
                            if(itemValue.is_vertical){
                                liElement.attr('data-vertical',"true");
                                liElement.addClass('mg-i-vertical');
                            }else{
                                horzontalCounter++;
                                if(horzontalCounter%18==0){
                                    liElement.addClass(_this.useMixedViewWithBigVertical?'mg-i-horizontal-x2':'mg-i-horizontal');
                                    if(_this.useMixedViewWithBigVertical){
                                        $(liElement).find("img:first").attr("src",$(liElement).find("img:first").attr("data-big-img"))/*.css("height",itemValue.ybig).css("width",itemValue.xbig)*/;
                                    }
                                    horzontalCounter=1;
                                }else{
                                    liElement.addClass('mg-i-horizontal');
                                }
                            }

                            if(_this.useMixedView){
                                if(parentElement==".performercontent"){
                                    _this.grid.append(liElement).packery( 'appended',liElement );
                                }
                                else{
                                    _this.gridVideos.append(liElement).packery( 'appended',liElement );
                                }
                            }else{
                                mediaElement.append(liElement);
                            }
                        } else if(itemValue.ext == 'video') {
                            let liElement=_this.addVideoLiElement(itemValue);
                            liElement.attr("data-id",'mg-item-'+itmeId).addClass('mg-item-'+itmeId);
                            liElement.addClass('mg-i-horizontal');
                            if(_this.useMixedView){
                                if(parentElement==".performercontent"){
                                    _this.grid.append(liElement).packery( 'appended',liElement );
                                }
                                else{
                                    _this.gridVideos.append(liElement).packery( 'appended',liElement );
                                }
                            }else{
                                mediaElement.append(liElement);
                            }
                        }

                        // shows Fan Club banner after third media item
                        if (_this.fanClubBannerRendered === false && counter === 3) {
                            renderFanClubBanner(dataJson.fanclub, _this.profileLastId, mediaElement);
                            _this.fanClubBannerRendered = true;
                            counter++;
                        }
                    });
                    if(_this.useMixedView){
                        for (var i = 0; i < 10; i++) {
                            if(!$("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                                break;
                            }
                            setTimeout(function () {
                                    if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                                        if(parentElement==".performercontent"){
                                            _this.grid.packery();
                                        }
                                        else{
                                            _this.gridVideos.packery();
                                        }
                                    }
                                },500*i*(i/2) );
                        }
                    }
                    _this.roomlist.helpers.log("medirender data: "+dataJson.media.length+" "+profilePage+"/");
                }

                /**
                 * Renders Fan Club banner.
                 *
                 * @param {Object} fanclub
                 * @param {Number} roomId
                 * @param {Object} container
                 */
                function renderFanClubBanner(fanclub, roomId, container) {
                    // @ts-ignore
                    const loggedIn = window.chatClient.app.options.auth.tokenID !== 'guest';
                    // @ts-ignore
                    const language = __currLang;
                    const babesHandler = _this.roomlist.babesHandler;

                    if (!fanclub || (loggedIn === true && (typeof fanclub !=="undefined" && fanclub.hasActiveSubscription === true))) {
                        return false;
                    }
//happy-hour-promo
                    const banner = $('<li>').addClass('doubleheight fanclub-banner happy-hour-promo'+(_this.useMixedView?' mg-i-vertical mg-item':'')).html('\
                        <div class="fanclub-banner-cont">\
                            <div class="fanclub-banner-box">\
                                <div class="fanclub-banner-box-inner">\
                                    <div class="content">\
                                        <h2 class="title">' + _this.roomlist.helpers.getTranslate('fanclub_banner_be_my_fan') + '</h2>\
                                        <div class="counter-container">\
                                            <div class="counter">+' + fanclub.extraMediaCount + '</div>\
                                            <div class="counter-text counter-text-' + language + '"><span>' + _this.roomlist.helpers.getTranslate('fanclub_banner_premium') + '</span> ' + _this.roomlist.helpers.getTranslate('fanclub_banner_picture_and_video') + '</div>\
                                        </div>\
                                        <ul>\
                                            <li>' + _this.roomlist.helpers.getTranslate('fanclub_banner_feature_private_message') + '</li>\
                                            <li>' + _this.roomlist.helpers.getTranslate('fanclub_banner_feature_own_appointment') + '</li>\
                                            <li>' + _this.roomlist.helpers.getTranslate('fanclub_banner_feature_fresh_premium_content') + '</li>\
                                        </ul>\
                                        <div class="btn-container">\
                                        <div class="btn-container">\
                                            <button class="btn" type="button">' + _this.roomlist.helpers.getTranslate('fanclub_banner_btn_membership') + '</button>\
                                        </div>\
                                    </div>\
                                    <a href="#" class="link-overlay"></a>\
                                </div>\
                            </div>\
                        </div>\
                    ');

                    banner.find('.link-overlay').click(e => {
                        e.preventDefault();

                        if (loggedIn === true) {
                            // @ts-ignore
                            window.sxc.fanclub.panel.showSubscribe(_this.roomlist.roomView.last_opened_room, __fanclubCurrency);
                        } else {
                            // @ts-ignore
                            window.chatClient.app.showRegisterNeeded('free');
                        }
                    });

                    if(_this.useMixedView){
                        if(parentElement==".performercontent"){
                            _this.grid.append(banner).packery( 'appended',banner );
                        }
                        else{
                            _this.gridVideos.append(banner).packery( 'appended',banner );
                        }
                    }else{
                        container.append(banner);
                    }
                }

                /**
                 * Render Fan Club media items.
                 *
                 * @param {Object} fanclub
                 * @param {Number} roomId
                 */
                function renderFanClubMediaItems(fanclub, roomId) {
                    console.log("renderFanClubMediaItems");
                    // @ts-ignore
                    const loggedIn = window.chatClient.app.options.auth.tokenID !== 'guest';

                    // locks media items
                    if (loggedIn === true && fanclub.hasActiveSubscription === false) {
                        $('.fanclub.mediagallery').addClass('blockedcontent');
                    }

                    let horzontalCounter=1;
                    let verticalCounter=1;
                    fanclub.mediaList.map((item, index) => {
                        const img = $('<img>')
                            .addClass('lazyload')
                            .attr('data-src', item.thumbnail)
                            .attr('src', item.thumbnail)
                            .attr('data-big-img', item.poster_bigbox);

                        const thumbnail = $('<div>').addClass('thumbnail');
                        thumbnail.append(img);

                        const badge = $('<span>')
                            .addClass('badge-exclusive')
                            .html(_this.roomlist.helpers.getTranslate('badge_exclusive'));

                        const boxInner = $('<div>').addClass('box-inner profile').append(thumbnail);
                        if (item.type === 'video') {
                            boxInner.append($('<div>').addClass('video'));
                        }

                        const link = $('<a>').attr('href','#').addClass('link');
                        if (fanclub.hasActiveSubscription === true && item.source) {
                            if(item.type === 'video'){
                                link.addClass('fancybox').attr('data-fancybox-videos', '').attr('data-src', '#videoModal') .attr('data-modal', 'false');
                                link.click(function (){
                                    _this.onVideoOverlayClick({id:item.source});
                                });
                            }else{
                                link.attr('href', item.source)
                                    .attr('data-thumb', item.thumbnail)
                                    .attr('data-fancybox', 'gallery1')
                                    .attr("data-protect",'true')
                                    .addClass('fancybox');
                            }
                        }

                        const box = $('<div>').addClass('box').append(boxInner).append(link);
                        box.append(badge);

                        const ms = new Date().getTime();
                        const listItem = $('<li>')
                            .attr('data-id', 'mg-item-' + ms + (index + 1))
                            .addClass('mg-item')
                            .addClass('mg-item-'+ ms + (index + 1))
                            .mousedown(() => {
                                if (loggedIn === true) {
                                    if (fanclub.hasActiveSubscription === true) {
                                        // @ts-ignore
                                        babesHandler.activitycheckeradd();
                                    } else {
                                        // @ts-ignore
                                        window.sxc.fanclub.panel.showSubscribe(_this.roomlist.roomView.last_opened_room, __fanclubCurrency);
                                    }
                                } else {
                                    // @ts-ignore
                                    window.chatClient.app.showRegisterNeeded('free');
                                }
                            })
                            .append(box);

                        if(_this.useMixedViewFanclub){
                            if(item.is_vertical){
                                verticalCounter++;
                                $(listItem).attr('data-vertical',"true");
                                $(listItem).addClass('mg-i-vertical');
                                if(_this.useMixedViewWithBigVertical){
                                    $(listItem).find("img:first").attr("src",$(listItem).find("img:first").attr("data-big-img"));
                                }
                            }else{
                                horzontalCounter++;
                                if(horzontalCounter%18==0){
                                    $(listItem).addClass(_this.useMixedViewWithBigVertical?'mg-i-horizontal-x2':'mg-i-horizontal');
                                    if(_this.useMixedViewWithBigVertical){
                                        $(listItem).find("img:first").attr("src",$(listItem).find("img:first").attr("data-big-img"));
                                    }
                                    horzontalCounter=1;
                                }else{
                                    $(listItem).addClass('mg-i-horizontal');
                                }
                                //$(listItem).addClass('mg-i-horizontal');
                            }

                            _this.gridFanclub.append(listItem).packery( 'appended',listItem );
                        }else{
                            fanclubElement.append(listItem);
                        }
                    });

                    if(_this.useMixedViewFanclub){
                        for (var i = 0; i < 10; i++) {
                            if(!$("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                                break;
                            }
                            setTimeout(function () {
                                if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                                    _this.gridFanclub.packery();
                                }
                            },500*i*(i/2) );
                        }
                    }else{
                        /** @ts-ignore */
                        lazyload();
                    }
                }

                function addgiftsTab(roomId2){
                    if($("#myPage .send-gift").length>0){return;}

                    //gift lista
                    let giftshtml='<div id="myPage"><div class="send-gift"><div class="normal-gifts">';

                    $.each(dataJson.gifts.full, function(itemKey, itemValue) {
                        giftshtml+='<div class="category"><h1>'+itemValue.name+'</h1><div class="list clearfix">';
                        $.each(itemValue.items, function(itemKey2, itemValue2) {
                            giftshtml+='<div class="gift" data-id="'+itemValue2.id+'" data-price="'+itemValue2.price+'" data-roomid="'+roomId2+'"><div class="inner">' +
                                '<img src="'+dataJson.gifts.imageServerAssetURL+'/gift/'+itemValue2.id+'.png?v=1" class="image" alt="'+itemValue2.name+'" />' +
                                '<div class="details"><div class="name">'+itemValue2.name+'</div><div class="price">'+itemValue2.priceText+'</div></div>' +
                                '<div class="details2"><input type="button" class="button choose" value="'+_this.roomlist.helpers.getTranslate('mypage_gift_page_purchase')+'"/></div>';
                            giftshtml+='</div></div>';
                        });
                        giftshtml+='</div></div>';
                    });
                    giftshtml+='</div></div></div>';
                    giftsElement.append(giftshtml);

                    let gift_interval1=-1;

                    //listában kattintás gift-re
                    giftsElement.find(".gift").click(function () {
                        window["chatClient"].app.view.giftPanel.openGiftDialog($(this).attr("data-id"),$(this).attr("data-price"),$(this).attr("data-roomid"),dataJson.name,$(this).find(".image").attr("src"),$(this).find(".name").text());
                    });
                }

            }

            /**
             * Handles visibility of Fan Club action button.
             *
             * @param {Object} fanclub
             */
            function handleFanClubButtonVisibility(fanclub) {
                if(typeof fanclub==="undefined" || !fanclub){return false;}

                if(!$("#profile_fanclub_li").hasClass("selected")){
                    if(window.location.href.indexOf("#fanclub")!==-1){
                        window.history.pushState({},"", window.location.href.replace("#fanclub",""));
                    }
                }

                // @ts-ignore
                const loggedIn = window.chatClient.app.options.auth.tokenID !== 'guest';
                const btn = $('.btn-action');

                // shows button on all tabs if there is an active subscription
                if (loggedIn === true && fanclub.hasActiveSubscription === true) {
                    btn.show();
                    return false;
                }

                // shows button only on certain tabs if there is no active subscription
                const selectedTab = $("#perfnavul > li.selected").attr('id');
                const allowedTabs = ['profile_fanclub_li'];

                if (allowedTabs.indexOf(selectedTab) !== -1) {
                    btn.show();
                } else {
                    //btn.hide();
                }
            }

            function desclick(fanclub) {
                contentElement.hide(); fanPacksElement.hide();videosElement.hide();giftsElement.hide(); fanclubElement.hide();descElement.show();
                giftpricesElement.hide();
                $("#perfnavul > li").removeClass("selected");
                $("#profile_desc_li").addClass("selected");
                handleFanClubButtonVisibility(fanclub);
                _this.scrollToMenu();
            }

            function scroller() {
                if (_this.pagingProcess !== false || _this.profileMedia === null
                    || (_this.profilePage >= _this.profileMediaMaxPage && $("#profile_gallery_li").hasClass("selected"))
                    || (_this.profilePageVideos >= _this.profileMediaMaxPageVideos && $("#profile_videos_li").hasClass("selected"))
                    || $("#profile_desc_li").hasClass("selected")  || $("#profile_gifts_li").hasClass("selected")) { return; }

                var minScrollTime = 100;
                var now = new Date().getTime();

                let processScroll = (parentelement,profilePage,profileMediaMaxPage,profileMedia) => {
                    _this.roomlist.helpers.log("scrolll processScroll");
                    let scrollerTop  = $("#frame_chat-app").height();
                    let windowHeight =$(window).scrollTop()+$(window).height();

                    if(scrollerTop - windowHeight < 50) {
                        _this.roomlist.helpers.log("scrolll mediaRenderer " + profilePage + "/" + profileMediaMaxPage + " profileMedia length:" + profileMedia.media.length + " parentelement:" + parentelement);
                        mediaRenderer(profileMedia, parentelement, profilePage, true);
                        if(!_this.useMixedView) {
                            let sordb = _this.roomlist._getColcountPerRow('.performercontent .mediagallery .mg-item');
                            if (_this.profileMedia.media.length > 4 && _this.profileMedia.media.length > (sordb * (_this.roomlist.bigroomrowsize + _this.roomlist.bigroomstartrow - 1) - (_this.roomlist.bigroomrowsize * _this.roomlist.bigroomcolsize))) {
                                _this.roomlist.addBigroomsAndLAstroomsInPopup(parentelement, parentelement == ".performercontent" ? _this.profilePage : _this.profilePageVideos, profileMediaMaxPage);
                            }
                        }
                    }
                }

                let processScrollFanclub = (parentelement,profilePage,profileMediaMaxPage,profileMedia) => {
                    if(!_this.useMixedView){
                        _this.roomlist.addBigroomsAndLAstroomsInPopupFanclub(parentelement,profilePage,profileMediaMaxPage);
                    }
                }

                if (typeof scrollTimer=="undefined" || scrollTimer==null) {
                    if (now - lastScrollFireTime > (3 * minScrollTime)) {
                        try{clearTimeout(scrollTimer);}catch (e) { }
                        _this.roomlist.helpers.log("scrolll triggered "+(now - lastScrollFireTime )+" "+(3 * minScrollTime));
                        lastScrollFireTime = now;
                        // fire immediately on first scroll
                        if($("#profile_gallery_li").hasClass("selected")){ processScroll(".performercontent",_this.profilePage,_this.profileMediaMaxPage,_this.profileMedia);  }
                        else if($("#profile_videos_li").hasClass("selected")){ processScroll(".videogallery",_this.profilePageVideos,_this.profileMediaMaxPageVideos,_this.profileMediaVideos);  }
                        else if($("#profile_fanclub_li").hasClass("selected")){ processScrollFanclub(".fanclub.mediagallery",_this.profilePage,_this.profileMediaFanClubMaxPage,_this.profileMediaFanClub);  }
                    }else{
                        try{clearTimeout(scrollTimer);}catch (e) { }
                        scrollTimer = setTimeout(function() {
                            _this.roomlist.helpers.log("scrolll triggered timeout");
                            scrollTimer = null;
                            lastScrollFireTime = new Date().getTime();
                            if($("#profile_gallery_li").hasClass("selected")){ processScroll(".performercontent",_this.profilePage,_this.profileMediaMaxPage,_this.profileMedia);  }
                            else if($("#profile_videos_li").hasClass("selected")){ processScroll(".videogallery",_this.profilePageVideos,_this.profileMediaMaxPageVideos,_this.profileMediaVideos);  }
                            else if($("#profile_fanclub_li").hasClass("selected")){ processScrollFanclub(".fanclub.mediagallery",_this.profilePage,_this.profileMediaFanClubMaxPage,_this.profileMediaFanClub);  }
                        }, minScrollTime);
                    }
                }
            }
        }


        addVideoLiElement(itemValue, isMainGallery=false) {
            let thiref=this;
            let picElement   = $('<img>').attr('src', itemValue.poster_thumb).attr('data-big-img', itemValue.poster_bigbox);
            let linkElement  = $('<a>').attr('href', 'javascript:;').append(picElement);
            let stateElement = $('<div>').addClass('video');
            let innerElement = $('<div>').addClass('box-inner').append(linkElement).append(stateElement);
            if(isMainGallery){
                let videolength=(new Date(itemValue.length * 1000).toISOString().substr(11, 8)).replace(/^00\:/g, '');
                innerElement.append('<div class="info"><div class="vid-title">'+itemValue["title"]+'</div><div class="length">'+videolength+'</div></div>')
            }
            let boxElement   = $('<div>').addClass('box').append(innerElement);
            let overlayElement = $('<div>').addClass('event-overlay');

            if (window["chatClient"].app.options.auth.tokenID !== "guest") {
                overlayElement.addClass('fancybox').attr('data-fancybox-videos', '').attr('data-src', '#videoModal') .attr('data-modal', 'false');
            }
            let liElement    = $('<li>').addClass('mg-item').addClass('profile-video-item').append(boxElement).append(overlayElement);
            if(isMainGallery){
                liElement.append('<div class="info-profile"><a href="/mypage/'+itemValue["perfid"]+'/'+thiref.roomlist.helpers.escapeHtml(itemValue["screenName"])+'" title="'+thiref.roomlist.helpers.escapeHtml(itemValue["screenName"])+'" target="_blank"><img src="'+itemValue["profilepic"]+'" /></a></div>')
            }

            if (window["chatClient"].app.options.auth.tokenID !== "guest") {
                overlayElement.on('click', () => {
                    thiref.onVideoOverlayClick(itemValue,isMainGallery);
                });
            }
            liElement.addClass('mg-i-horizontal');
            return liElement;
        }


        onVideoOverlayClick(itemValue, isMainGallery=false){
            let _this= this;
            $('#video-player, #video-poster').hide();
            $('#video-poster').parent().find('a').remove();
            $('#video-message').hide();
            if( $('#video-message').parent().find('#video-title').length==0){
                $('#video-message').after('<div id="video-title"></div>');
            }
            $("#videoModal .loading-animation-1").hide();

            let videoObj = <HTMLVideoElement>document.getElementById('video-player');
            videoObj.muted = window["cookie"].read("vid_muted")=="0"?false:true;
            videoObj.controls = true;

            videoObj.pause();
            videoObj.removeAttribute("src");
            videoObj.load();

            $(videoObj).on('play pause ended timeupdate volumechange', function () {
                let thiref=$(this);
                setTimeout(function () {
                    window["cookie"].erase("vid_muted");
                    if(!(<HTMLVideoElement>thiref[0]).muted){
                        window["cookie"].create("vid_muted","0");
                    }
                },300);
            });

            $.ajax({
                url: 'https://videoman.a.apn2.com/api/videoPlayer/video/' + itemValue.id + '?tokenID=' + window["chatClient"].app.options.auth.tokenID,
                dataType: 'json'
            }).done((videoData) => {

                let videolength=(new Date(videoData.length * 1000).toISOString().substr(11, 8)).replace(/^00\:/g, '');

                let videotitle=videoData.title;
                if(typeof videoData.title === 'object'){
                    if(typeof videoData.title.en === 'undefined'){videotitle=videoData.title[Object.keys(videoData.title)[0]];}
                    else{videotitle=videoData.title.en;}
                }

                $('#video-title').html(videotitle+' <div class="videolength">'+videolength+'</div>');

                if(isMainGallery){
                    $(".main-gallery-profile").remove();
                    $('#video-title .videolength').after('<div class="main-gallery-profile"><div class="gallery-info-cont"><div class="gallery-info-profile-with-dot"><a class="gallery-link" href="/mypage/'+itemValue["perfid"]+'/'+_this.roomlist.helpers.escapeHtml(itemValue["screenName"])+'" title="'+_this.roomlist.helpers.escapeHtml(itemValue["screenName"])+'" target="_blank"><img src="'+itemValue["profilepic"]+'" /></a></div><div class="gallery-green-dot"></div></div></div>');
                    videotitle+="<br><br><br>";
                    $("#videoModal").addClass("from-video-gallery");
                    $(".gallery-green-dot").addClass("hidden");
                    $.ajax({  url: '/ajax/api/roomList/babes-get-profile?perfid='+itemValue["perfid"], dataType: 'json'}).done((dataJson) => {
                        if (typeof dataJson["onlinestatus"] !== "undefined" && dataJson["onlinestatus"]!=="offline") {
                            $(".gallery-green-dot").removeClass("hidden");
                        }
                    });
                }else{
                    $("#videoModal").removeClass("from-video-gallery");
                }

                if (videoData.status === 402) {
                    _this.roomlist.helpers.log(videoData);
                    $('#video-poster').attr('src', itemValue.poster).show();
                    let buyButton = $('<a>').attr('href', 'javascript:void(0)').addClass('buy-button');
                    buyButton.html('<div class="round">'+_this.roomlist.helpers.getTranslate("profile_gallery_show_video_before")+'<div class="length">'+videolength+'</div></div>' +
                        '<div class="round-hover"><span>'+_this.roomlist.helpers.getTranslate("profile_gallery_show_video")+'</span><div class="credits">'+videoData.price+' '+_this.roomlist.helpers.getTranslate("profile_gallery_show_video_credits")+'</div></div>');
                    buyButton.on('click', () => {
                        $("#videoModal .loading-animation-1").show();
                        $("#videoModal .buy-button").addClass("hidden");
                        $.post('https://videoman.a.apn2.com/api/videoPlayer/purchase/' + itemValue.id + '?tokenID=' + window["chatClient"].app.options.auth.tokenID, {}, (data) => {
                            $("#videoModal .loading-animation-1").hide();
                            $("#videoModal .buy-button").removeClass("hidden");
                            if (data.success === true) {
                                $('#video-player').show();
                                $('#video-poster').hide();
                                $('#video-poster').parent().find('a.buy-button').remove();

                                if(shaka.Player.isBrowserSupported() && typeof videoData.drm!=="undefined" && !_this.roomlist.helpers.isiOS() ){
                                    _this.roomlist.videoPlayer.playVideoWithDashOrHls(videoData.drm,window["chatClient"].app.options.auth.tokenID,videoObj,_this.roomlist.shakaPlayer,data.url);
                                }else{
                                    videoObj.src = data.url;
                                    videoObj.load();
                                    videoObj.play();
                                }

                                $("#video-title").fadeOut("fast").delay(3000).fadeIn();
                                $("#video-message").html( _this.roomlist.helpers.getTranslate('profile_gallery_show_video_successful_buy')).removeClass("middle");
                                $("#video-message").fadeIn("fast").delay(3000).fadeOut();

                                $(".sxcc-wrapper:not(.hiddenchat) .sxcc-volume-control button:not(:has(.sxcc-icon-vol0))").click();//mute chat
                            } else {
                                if (data.reason == 'ooc') {
                                    $('#video-message').html(window["chatClient"].app.translator.t("ooc_default")).show();
                                    $('#video-message').addClass("middle");
                                    $('#video-message').click(function () {
                                        $("button[data-fancybox-close]").click();
                                        // @ts-ignore
                                        window["chatClient"].app.view.topupPanel.show();
                                    });
                                    if(window['chatClient'].app.isMobileView()){
                                        $("#video-title").css("visibility","hidden");
                                        setTimeout(function () {  $("#video-title").css("visibility","visible"); },10000)
                                    }
                                    $('#video-message').delay(10000).fadeOut();
                                }
                            }
                        });
                    });
                    $('#video-poster').parent().append(buyButton);
                } else {
                    $('#video-player').show();

                    if(shaka.Player.isBrowserSupported() && typeof videoData.drm!=="undefined" && !_this.roomlist.helpers.isiOS()){
                        _this.roomlist.helpers.log("shakaPlayer");
                        _this.roomlist.videoPlayer.playVideoWithDashOrHls(videoData.drm,window["chatClient"].app.options.auth.tokenID,videoObj,_this.roomlist.shakaPlayer,videoData.url);
                    }else{
                        _this.roomlist.helpers.log("no shakaPlayer");
                        videoObj.src = videoData.url;
                        videoObj.load();
                        videoObj.play();
                    }


                    $(".sxcc-wrapper:not(.hiddenchat) .sxcc-volume-control button:not(:has(.sxcc-icon-vol0))").click();//mute chat
                }
            });
            _this.roomlist.babesHandler.activitycheckeradd();
        }

        facybox_settings(){
            let thisref= this;
            $('[data-fancybox],[data-fancybox-videos]').fancybox({
                // loop : true,
                //touch: false,
                animationEffect: "fade",
                thumbs : {
                    autoStart   : false
                },
                slideShow: {
                    autoStart: false,
                    speed: 3000
                },
                clickContent : function( current, event ) {
                    return current.type === 'image' ? false/*'zoom'*/ : false;
                },
                afterLoad : function(instance, current) {
                    if(current.type === "video" ){
                        current.$content.find('video').trigger('play');
                        current.$content.find('video').on('ended', function() {
                            // @ts-ignore
                            //$.fancybox.next();
                        });
                    }
                },
                afterShow: function(instance, current) {
                    //thisref.helpers.log("afterShow2");
                }
            });
        }

        async initLovense(perfid){
            if(this.lovenseWebTurnedOn){
                try{
                    this.destroyLovense();
                    if(typeof this.profileMediaVideos["lovense"] !== "undefined" &&
                        typeof this.profileMediaVideos["lovense"]["memberKey"] !== "undefined" &&
                        typeof this.profileMediaVideos["lovense"]["perfKey"] !== "undefined" &&
                        this.profileMediaVideos["lovense"]["memberKey"]!=="" &&
                        this.profileMediaVideos["lovense"]["perfKey"]!=="" ){
                        // @ts-ignore
                        Lovense.init("Adult Performer Network", this.profileMediaVideos["lovense"]["perfKey"], this.profileMediaVideos["lovense"]["memberKey"]);
                        this.addLovenseTranslations();
                        console.log("initLovense");
                    }
                }catch (err){console.error(err);}
            }
        }

        destroyLovense(){
            if(this.lovenseWebTurnedOn) {
                try {// @ts-ignore
                    Lovense.destroy();
                } catch (err) {
                }
            }
        }

        async addLovenseTranslations(){
            let _this = this;
            await this.roomlist.babesHandler.waitForEl("#lvs-control-panel .lvs-tip-pl__table th:eq(0)");
            $(".lvs-tip-pl__tip-panel-title span:first").text(_this.roomlist.helpers.getTranslate("lovense_panel"));
            $("#lvs-control-panel .lvs-tip-pl__table").each(   function() {
                $(this).find("th:eq(0)").text(_this.roomlist.helpers.getTranslate("lovense_credit"));
                $(this).find("th:eq(1)").text(_this.roomlist.helpers.getTranslate("lovense_interval"));
                $(this).find("th:eq(2)").text(_this.roomlist.helpers.getTranslate("lovense_strength"));
            });

            $(".giftprices").html("");
            $(".giftprices").append($("#lvs-control-panel .lvs-tip-pl").html());
            let tbl1 = $("[data-swiper-slide-index='0'] tbody").html();
            let tbl2 = $("[data-swiper-slide-index='1'] tbody").html();
            let tbl3 = $("[data-swiper-slide-index='2'] tbody").html();
            let tbl4 = $("[data-swiper-slide-index='3'] tbody").html();
            $(".giftprices .swiper-wrapper div:first tbody").html("").append(tbl1).append(tbl2).append(tbl3).append(tbl4);

            // @ts-ignore
            if(__isLoggedMember  === true && $(".sxccp-smarttips-wrapper").is(":visible")){
                $("#profile_giftprices_li").removeClass("hidden");
            }
        }

    }
}